import { makeStyles } from '@material-ui/core/styles'

export const paymentAccountEmptyStateIconProps = {
  highlightColor: '#C5A561',
  iconColor: '#FFFFFF',
}

export const useStyles = makeStyles(theme => ({
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 1.5),
    },
  },
  cardTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    color: '#00205B',
  },
  cardDivider: {
    height: 1,
    backgroundColor: '#E0E0E0',
  },
  cardContent: {
    padding: theme.spacing(0, 3, 3),
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2, 2),
    },
  },
  rowDivider: {
    marginLeft: theme.spacing(-3),
    marginRight: theme.spacing(-3),
    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
  },
  accountRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 0),
  },
  rowMain: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
    flex: '1 1 auto',
  },
  mobileChipRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(1),
    marginLeft: 52,
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#EBF0F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  accountIcon: {
    color: '#172024',
  },
  accountName: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.4,
    color: '#172024',
  },
  chipRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.75),
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  statusChip: {
    borderRadius: 8,
    height: 22,
    fontSize: '0.625rem',
    fontWeight: 500,
    letterSpacing: '0.02em',
  },
  activeChip: {
    backgroundColor: '#BEF1BB',
    color: '#00210B',
  },
  stripeSetupIncompleteChip: {
    backgroundColor: '#E0EAFF',
    color: '#001C57',
  },
  unableToAcceptPaymentsChip: {
    backgroundColor: '#FFBCBC',
    color: '#410002',
  },
  payoutsOnHoldChip: {
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
  errorIcon: {
    color: 'inherit',
    fontSize: '0.875rem !important',
  },
  rowActions: {
    flexShrink: 0,
  },
  menuButton: {
    padding: 6,
    color: '#6B7C87',
    '&:hover': {
      backgroundColor: '#F4F6F8',
      color: '#172024',
    },
  },
  menuItemIcon: {
    color: '#172024',
    minWidth: theme.spacing(5),
    '& .MuiSvgIcon-root': {
      color: 'inherit',
      fontSize: 20,
    },
  },
  warningBox: {
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1.5),
    borderRadius: 8,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: '#172024',
  },
  chargesDisabledWarning: {
    backgroundColor: '#FEECEA',
    border: '1px solid #F5C4BF',
  },
  payoutsDisabledWarning: {
    backgroundColor: '#F8F0D8',
    border: '1px solid #E8D9B0',
  },
  detailsNotSubmittedWarning: {
    backgroundColor: '#F4F7F9',
    border: '1px solid #E0E0E0',
  },
  combinedWarning: {
    backgroundColor: '#F4F7F9',
    border: '1px solid #E0E0E0',
  },
}))
